//#region Tab

$(document).on('countTabsChildren', '.children-tab-counter', function (e) {
    let tabIndex = $(this).data('index');
    let $item = $(this).closest('[id^=tabs-]').find(`.nav-item:eq(${tabIndex})`)

    let sum = 0;

    $(this).find('.nav-item:not(.ignore-tab-counter)')
        .find('.tab-filter-items-count-value')
        .each(function () {
            let value = parseInt($(this).text(), 10);
            if (!isNaN(value)) {
                sum += value;
            }
        });

    $item.find('.tab-filter-items-count-value').text(sum)
});


$(document).on('setItemsCount', '.kdr-filters-tabs .nav-link', function (e) {
    let $item = $(this)
    let $container = $item.find('.tab-filter-items-count')
    let $itemCounter = $container.find('.tab-filter-items-count-value')
    if (e.count == undefined || e.count == null || e.count === -1 /*|| $container.closest('.nav-item').hasClass('ignore-tab-counter')*/) {
        $container.hide()
    } else if ($container.closest('.nav-item').hasClass('ignore-tab-counter')) {
        $container.hide()
        $itemCounter.text(e.count);

    } else if ($itemCounter.prop('Counter') != e.count) {
        $container.fadeIn(50)

        $itemCounter.prop('Counter', 0).animate(
            {
                Counter: e.count
            },
            {
                duration: 1500,
                easing: 'swing',
                step: function (now) {
                    $(this).text(Math.ceil(now));
                },
                complete: function () {
                    if ($('.children-tab-counter').length > 0) {
                        $('.children-tab-counter').trigger({
                            type: 'countTabsChildren'
                        })
                    }
                }
            });
    }
})

$(document).on(gridEvents.AFTER_UI_INIT, '.default-tab-counter', function () {
    let $grid = $(this)
    let tabIndex = $grid.closest('.tab-pane').index()
    let $tab = $grid.closest('[id^="tabs-"]')
    let $tabLinkButton = $tab.find(`.nav-item:eq(${tabIndex}) .nav-link`)
    let itemsCount = $grid.find('.items-count-value').text() * 1

    if ($grid.closest('.tab-pane').find('.kdr-filters-tabs').length > 0) {
        let sum = 0;

        $grid.find('.nav-item:not(.ignore-tab-counter)')
            .find('.tab-filter-items-count-value')
            .each(function () {
                let value = parseInt($(this).text(), 10);
                if (!isNaN(value)) {
                    sum += value;
                }
            });

        $tabLinkButton.trigger({
            type: 'setItemsCount',
            count: sum
        })
    }
    else {

        $tabLinkButton.trigger({
            type: 'setItemsCount',
            count: itemsCount
        })
    }
})

//#endregion Tab